Object.defineProperty(exports,"__esModule",{value:true});var _last2=require("lodash/last");var _last3=_interopRequireDefault(_last2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);
var _victoryCore=require("victory-core");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=

{

getBaseProps:function getBaseProps(props,fallbackProps){
props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"area");var _getCalculatedValues=
this.getCalculatedValues(props),scale=_getCalculatedValues.scale,style=_getCalculatedValues.style,data=_getCalculatedValues.data,domain=_getCalculatedValues.domain;var _props=
props,standalone=_props.standalone,interpolation=_props.interpolation,label=_props.label,width=_props.width,height=_props.height,groupComponent=_props.groupComponent;

var dataProps={
groupComponent:groupComponent,
key:"area",
data:data,
scale:scale,
interpolation:interpolation,
style:style.data};


var baseProps={
parent:{style:style.parent,width:width,height:height,scale:scale,data:data,domain:domain,standalone:standalone},
all:{
data:dataProps}};



if(label!==undefined&&label!==null||props.events||props.sharedEvents){
baseProps.all.labels=this.getLabelProps(dataProps,label,style);
}

return baseProps;
},

getLabelProps:function getLabelProps(dataProps,text,calculatedStyle){var
data=dataProps.data,scale=dataProps.scale;
var lastData=(0,_last3.default)(data);
var labelStyle=_victoryCore.Helpers.evaluateStyle(calculatedStyle.labels,data)||{};
var labelPadding=labelStyle.padding||0;

return{
key:"area-label",
x:lastData?scale.x(lastData._x)+labelPadding:0,
y:lastData?scale.y(lastData._y1):0,
y0:lastData?scale.y(lastData._y0):0,
style:calculatedStyle.labels,
textAnchor:labelStyle.textAnchor||"start",
verticalAnchor:labelStyle.verticalAnchor||"middle",
angle:labelStyle.angle,
data:data,
scale:scale,
text:text};

},

getCalculatedValues:function getCalculatedValues(props){var
theme=props.theme;
var defaultStyles=theme&&theme.area&&theme.area.style?theme.area.style:{};
var style=_victoryCore.Helpers.getStyles(props.style,defaultStyles,"auto","100%");
var range={
x:_victoryCore.Helpers.getRange(props,"x"),
y:_victoryCore.Helpers.getRange(props,"y")};

var domain={
x:_victoryCore.Domain.getDomainWithZero(props,"x"),
y:_victoryCore.Domain.getDomainWithZero(props,"y")};

var scale={
x:_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x),
y:_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y)};


var data=this.getDataWithBaseline(props,scale);
return{style:style,data:data,scale:scale,domain:domain};
},

getDataWithBaseline:function getDataWithBaseline(props,scale){
var data=_victoryCore.Data.getData(props);

if(data.length<2){
_victoryCore.Log.warn("Area requires at least two data points.");
data=[];
}
var defaultMin=_victoryCore.Scale.getType(scale.y)==="log"?1/Number.MAX_SAFE_INTEGER:0;
var domainY=scale.y.domain();
var minY=Math.min.apply(Math,_toConsumableArray(domainY))>0?Math.min.apply(Math,_toConsumableArray(domainY)):defaultMin;

return data.map(function(datum){
var _y1=datum._y1!==undefined?datum._y1:datum._y;
var _y0=datum._y0!==undefined?datum._y0:minY;
return(0,_assign3.default)({},datum,{_y0:_y0,_y1:_y1});
});
}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/victory-area/helper-methods.js
// module id = 1385
// module chunks = 0